module.exports = __webpack_public_path__ + "static/logo-21351c7d63292e2ef08e7d55c8dc3cd8.png";